export default "__VITE_ASSET__ZOkC61jK__"